import http from '@utils/http';

const communicationApi = {
  /**
   * 沟通会详情
   * @param id
   * @returns {Promise<unknown>}
   */
  detail(id) {
    return http
      .get(`/workscene/workscene/v1/business-meet/info/${id}`)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  /**
   * 提交反馈
   * @param params
   * @returns {Promise<unknown>}
   */
  submit(params) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    params = JSON.stringify(params);
    return http
      .post(
        '/workscene/workscene/v1/business-meet/confirm-submit',
        params,
        headers
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
};

export default communicationApi;
